module.exports = __webpack_public_path__ + "static/media/drSeif.58329544.jpeg";